module.exports = __webpack_public_path__ + "static/img/special-row.2d090bb1.png";